import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const SKYLINE = "https://images.unsplash.com/photo-1685697075117-d6e843ea515e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBwcm9mZXNzaW9uYWwlMjBmaW5hbmNlJTIwY2hhcnRlcmVkJTIwYWNjb3VudGFudCUyMG9mZmljZSUyMGRlbGhpJTIwbmNyfGVufDB8fHx8MTc5MDQzMTE0N3ww&ixlib=rb-4.1.0&q=80&w=1600&auto=format&fit=crop";

const AREAS = [
  { name: "Indirapuram", note: "Our home turf — resident welfare, retail and service businesses." },
  { name: "Raj Nagar", note: "Ghaziabad's commercial spine — traders, clinics and manufacturers." },
  { name: "Vaishali", note: "Metro-connected hub for startups, professionals and SMEs." },
  { name: "Delhi NCR", note: "Remote-first filings and representation across the entire NCR." },
];

export const Areas = () => (
  <section id="target-locations" className="py-16 sm:py-24 bg-white border-y border-slate-200" data-testid="areas-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="relative rounded-3xl overflow-hidden border border-slate-200">
            <img src={SKYLINE} alt="Delhi NCR skyline — areas served by Shashank Chaudhary & Co"
              className="h-[380px] sm:h-[460px] w-full object-cover" loading="lazy" data-testid="areas-image" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent" />
            <p className="absolute bottom-6 left-6 right-6 font-serif italic text-2xl text-white leading-snug">
              Local presence, NCR-wide practice.
            </p>
          </div>
        </Reveal>
        <div>
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-brass-dark font-semibold mb-4">Practice areas</p>
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-ink">
              Rooted in Ghaziabad. Working across NCR.
            </h2>
          </Reveal>
          <div className="mt-10 space-y-0">
            {AREAS.map((a, i) => (
              <Reveal key={a.name} delay={i * 0.07}>
                <div className="group flex items-start gap-4 py-5 border-b border-slate-200 first:border-t transition-colors duration-300 hover:bg-brass-light/50 -mx-3 px-3 rounded-lg" data-testid={`area-${a.name.toLowerCase().replace(/\s+/g, "-")}`}>
                  <MapPin size={20} className="mt-1 text-brass-dark shrink-0" strokeWidth={1.8} />
                  <div>
                    <h3 className="font-serif text-xl font-medium text-ink group-hover:text-brass-dark transition-colors duration-300">{a.name}</h3>
                    <p className="text-sm text-ink-muted mt-1">{a.note}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
